import React from 'react'
import {
    Typography,
    Grid,
    Box,
    Checkbox,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
} from '@mui/material'
import CustomDropdown from '../../CustomDropdownWithPlus'
import CustomTextField from '../../CustomTextField';
// import { labelStyle } from '../ShippingModal/index.controller';
const labelStyle = {
    fontSize: '14px !important',
    fontFamily: 'Nunito !important',
    color: '#555 !important'
};
const ThirdPartyForm = ({formData,handleSelect,handleInputChange, courierList}) => {
  return (
     <Grid item xs={7}>
            <Box className="field">
                <Typography sx={labelStyle}>Courier</Typography>
                <CustomDropdown
                    name="courier"
                    options={courierList}
                    handleSelect={handleSelect}
                    minWidth={"150px"}
                    selectedValue={formData.courier}
                    placeholder="Select courier"
                />
            </Box>

            <Box display="flex" alignItems="center" justifyContent='space-between' gap={1}>
                <Box className="field" sx={{ marginTop: '5px !important', width:'100% !important' }}>
                <Typography sx={labelStyle}>Account Name</Typography>
                    <CustomTextField
                        name="accountName"
                        value={formData.accountName}
                        isRequired
                        placeholder="Enter Account Name"
                        handleChange={handleInputChange}
                    />
            </Box>
            </Box>
                        <Box display="flex" alignItems="center" justifyContent='space-between' gap={1}>
                <Box className="field" sx={{ marginTop: '5px !important', width:'100% !important' }}>
                <Typography sx={labelStyle}>Account Number</Typography>
                    <CustomTextField
                        name="accountNumber"
                        value={formData.accountNumber}
                        isRequired
                        placeholder="Enter Account Number"
                        handleChange={handleInputChange}
                    />
            </Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent='space-between' gap={1}>
                <Box className="field" sx={{ marginTop: '5px !important', width:'100% !important' }}>
                <Typography sx={labelStyle}>Postal / Zip Code</Typography>
                    <CustomTextField
                        name="postalCode"
                        value={formData.postalCode}
                        isRequired
                        placeholder="Enter Postal / Zip Code"
                        handleChange={handleInputChange}
                    />
            </Box>
            </Box>
        </Grid>
  )
}

export default ThirdPartyForm